import React from 'react';
import { useSlate } from 'slate-react';
import { Icon } from '@plone/volto/components';
import {
  isBlockStyleActive,
  toggleStyle,
} from '@redturtle/volto-rt-slate/config/Slate/Dropdown/dropdownUtils';
import { Button } from 'semantic-ui-react';
import TextMarginIcon from '@redturtle/volto-io-studio/icons/text-margin.svg';

const TextMarginButton = (props) => {
  const editor = useSlate();
  const isActive = isBlockStyleActive(editor, 'text-margin', null);

  return (
    <div className="button-wrapper">
      <Button
        as="a"
        title="Testo con margin laterali"
        className="icon slate-text-margin"
        active={isActive}
        size="tiny"
        compact
        toggle
        onClick={(event, selItem) => {
          toggleStyle(editor, {
            cssClass: 'text-margin',
            isBlock: true,
          });
        }}
        {...props}
      >
        <Icon name={TextMarginIcon} size="24px" />
      </Button>
    </div>
  );
};

export default function installHR(config) {
  const { slate } = config.settings;

  slate.buttons['text-margin'] = TextMarginButton;

  slate.toolbarButtons.splice(
    slate.toolbarButtons.indexOf('align') + 1,
    0,
    'text-margin',
  );
  slate.expandedToolbarButtons.push('text-margin');
  slate.expandedToolbarButtons.splice(
    slate.expandedToolbarButtons.indexOf('align') + 1,
    0,
    'text-margin',
  );
  return config;
}
